import React from 'react';
import { formatVoucherDuration } from './durationUtil';

/**
 * CompactTemplate — 8 kolom × 5 baris = 40 voucher per halaman A4 landscape.
 * (Redesigned 2026-07-20: dari 25/page menjadi 40/page.)
 */
const CompactTemplate = ({ vouchers, companyLogo = '', companyName = '', batchHeader, templateSettings }) => {
  const today = new Date().toISOString().split('T')[0];
  const _dCfg = {
    font_brand: 4.5,   // footer "di-distribusikan oleh ..."
    font_plan: 8.5,    // isi value (Waktu & Voucher)
    font_label: 6.5,   // label "Waktu" / "Voucher"
    font_code: 8.5,    // (unused; kept for schema parity)
    plan_format: '{duration} - {price}',
    label_text: 'di-distribusikan oleh',
    prefix_text: 'No.',
  };
  const cfg = { ..._dCfg, ...(templateSettings || {}) };

  return (
    <div className="print-container-compact print-root">
      <style>{`
        @page {
          size: A4 landscape;
          margin: 2mm;
        }
        @media print {
          html, body { width: 100%; height: 100%; margin: 0 !important; padding: 0 !important; background: white !important; }
          html *:not(.print-root):not(.print-root *) { visibility: hidden !important; }
          .print-root, .print-root * { visibility: visible !important; }
          .print-root {
            position: absolute !important;
            left: 0 !important; top: 0 !important;
            transform: none !important;
            width: 100% !important;
          }
          .print-container-compact { background: white; padding: 0; }
        }

        .print-container-compact {
          width: 297mm;
          margin: 0 auto;
          padding: 2mm;
          background: #ffffff;
          display: flex;
          flex-wrap: wrap;
          gap: 0.5mm;
          align-content: flex-start;
        }

        .compact-card {
          width: calc((100% - 7 * 0.5mm) / 8);
          height: 38mm;
          border: 1px solid #b7b7b7;
          padding: 1.2mm 1.4mm;
          box-sizing: border-box;
          background: white;
          display: flex;
          flex-direction: column;
          page-break-inside: avoid;
          flex-shrink: 0;
        }

        .compact-header {
          text-align: center;
          border-bottom: 1px solid #ddd;
          padding-bottom: 0.6mm;
          margin-bottom: 0.4mm;
        }

        .compact-vnum {
          text-align: left;
          font-size: ${cfg.font_label}pt;
          font-weight: 700;
          color: #4a90e2;
          line-height: 1;
          margin-bottom: 0.6mm;
          padding-left: 0.5mm;
        }

        .compact-logo img {
          width: 100%;
          height: auto;
          max-width: 30mm;
          max-height: 8mm;
          object-fit: contain;
          display: block;
          margin: 0 auto;
        }

        .compact-body {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 0.4mm;
          margin-bottom: 0.5mm;
          justify-content: center;
        }

        .compact-col {
          display: flex;
          flex-direction: column;
          gap: 0mm;
          align-items: center;
        }

        .compact-label {
          font-size: ${cfg.font_label}pt;
          font-weight: 700;
          color: #4a90e2;
          text-align: center;
          margin-bottom: 0.2mm;
          line-height: 1;
        }

        .compact-value {
          font-size: ${cfg.font_plan}pt;
          font-weight: 800;
          color: #000;
          text-align: center;
          border: none;
          padding: 0.4mm 0.8mm;
          letter-spacing: 0.1mm;
          display: flex;
          align-items: center;
          justify-content: center;
          word-break: break-word;
          height: 5mm;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1;
        }

        .compact-footer {
          text-align: center;
          font-size: ${cfg.font_brand}pt;
          color: #4a90e2;
          line-height: 1.2;
          margin-top: auto;
        }
        .compact-footer-bold {
          font-weight: 800;
          color: #000;
        }
      `}</style>

      {batchHeader}
      {vouchers.map((voucher, index) => (
        <div key={voucher.id || index} className="compact-card" data-voucher-card>
          <div className="compact-header">
            <div className="compact-logo">
              <img src={companyLogo || ''} alt="Company Logo" />
            </div>
          </div>
          <div className="compact-vnum">{cfg.prefix_text} {String(index + 1).padStart(2, '0')}</div>

          <div className="compact-body">
            <div className="compact-col">
              <div className="compact-label">Waktu</div>
              <div className="compact-value">
                {formatVoucherDuration(voucher)}
              </div>
            </div>

            <div className="compact-col">
              <div className="compact-label">Voucher</div>
              <div className="compact-value">
                {voucher.voucher_code}
              </div>
            </div>
          </div>

          <div className="compact-footer">
            <div>di-generate {today}</div>
            <div className="compact-footer-bold">{cfg.label_text} {companyName || 'ISP Provider'}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CompactTemplate;
